import GooglePlayBadgeImg from "../assets/GooglePlayBadge.svg";


const GooglePlayBadge = ({ className = "", ...props }) => (
    <a
        href="https://play.google.com/store/apps/details?id=com.vespid.mobileapp"
        target="_blank"
        rel="noreferrer"
    >
        <img
            src={GooglePlayBadgeImg}
            alt="Google Play Badge"
            loading="lazy"
            className={className}
            {...props}
        />
    </a>
);

export default GooglePlayBadge;
